import React from 'react'
import { connect } from 'react-redux'
import { getTranslation } from '@/store/getters'
import { toggleToaster } from '@/store/actions'



import styles from './styles.scss'


const EmbedMagazine = props => {

  const handleCopy = () => {
    const { translation, handleClose, toggleToaster } = props
    const embed = document.getElementById('#embedMagazine')

    embed.select()
    document.execCommand('copy')

    handleClose()

    toggleToaster({
      isVisible: true,
      message: translation('embed-toaster-message'),
      position: 'top-right',
      type: 'success'
    })
  }


  const { show, translation, id_magazine, handleClose } = props

  // const embedUrl = process.env.NODE_ENV === 'development'
  //   ? `http://localhost:3000/publish/${id_magazine}`
  //   : `https://magazine.omb11.com/publish/${id_magazine}`

  const embedUrl = `${process.env.REACT_APP_HOST_URL}/publish/${id_magazine}`

  const value = `<iframe width="100%" height="100%" frameborder="0" src="${embedUrl}"></iframe>`

  return (
    <section className={'ba-flex ba-jc-center ba-ai-center ' + (show ? styles['ba-modal'] : styles['ba-none'])}>
      <div className={'ba-card ' + styles['ba-modal-card']}>
        <div className="ba-top ba-flex ba-jc-sb ba-ai-center">
          <h5 className="ba-montserrat-700">
            {translation('action-embed')}
          </h5>

          <button className='ba-btn ba-btn-close ba-sm ba-rounded'
            onClick={handleClose}>
            <builderall-icon code='64f7' />
          </button>
        </div>

        <hr className={'ba-mg-y-1 ba-hr ba-w-100'} />
        <div className="ba-content ba-w-100">
          <div className='ba-box-input ba-mg-t-1'>
            <textarea className={'ba-input ' + styles['no-resize']} id='#embedMagazine'
              rows="5"
              readOnly={true}
              placeholder={translation('embed-placeholder')}
              defaultValue={value} />
          </div>

          <div className='ba-flex ba-jc-fe ba-mg-t-3'>
            <button className='ba-btn ba-md ba-blue'
              onClick={handleCopy}>
              <builderall-icon code='b54c' />
              {translation('general-copy')}
            </button>
          </div>
        </div>
      </div>
    </section>
  )

}

const mapStateToProps = state => {
  const translation = getTranslation(state)
  return { translation }
}

export default connect(
  mapStateToProps, {
  toggleToaster
}
)(EmbedMagazine)



// WEBPACK FOOTER //
// ./src/components/EmbedMagazine/index.js